import { useState } from "react";
import { Modal, Tooltip } from "antd";
import { AnimatePresence } from "framer-motion";
import { ExpandAltOutlined, InfoCircleOutlined } from "@ant-design/icons";

//STYLES
import { PG } from "./style";
import { transition_default } from "../../../../../../utils";

//APP
import { obterMediaGeraldeUso } from "./meta";
import { Item__Atividades } from "../../../../../../services/atividades/GET";

//COMPONENTS
import { GaugeChart } from "./components/GaugeChart";
import { DefaultTitle } from "../defaultTitle";

//CONST
const segmento_permitido = ['', 'Todos', 'Insumos'];

//PROPS
interface Props {
    todas_atividades_ativas: Item__Atividades[];
    segmento: string;
}

export const MediaUsoGeralInsumos: React.FC<Props> = ({ todas_atividades_ativas, segmento }) => {

    const [modalAberto, setModalAberto] = useState(false);
    const media_geral_uso = obterMediaGeraldeUso(todas_atividades_ativas);

    return (
        <AnimatePresence>
            {segmento_permitido.includes(segmento) && (
                <PG
                    layout
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ y: 90, opacity: 0, transition: { delay: 0, ease: [0, 0.71, 0.2, 1.01] } }}
                    transition={{ ...transition_default, delay: 0.4 }}
                    key={'precisao_geral_insumos'}
                    data-segmento={segmento}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <DefaultTitle title="Consumo de insumos" fontSize={13} />
                        <Tooltip
                            title="Este gráfico mostra o consumo de insumos (Considerando apenas insumos com quantidade executada maior que zero). Valores próximos a 100% indicam que a aplicação foi realizada conforme o planejado. Valores acima de 100% indicam excesso, e abaixo de 100% indicam falta na aplicação."
                            placement="right"
                        >
                            <InfoCircleOutlined style={{ fontSize: 13, color: '#999', cursor: 'pointer', marginTop: -14 }} />
                        </Tooltip>
                    </div>
                    <ExpandAltOutlined
                        onClick={() => setModalAberto(true)}
                        style={{
                            fontSize: 14,
                            cursor: 'pointer',
                            color: '#999',
                            padding: 4,
                            borderRadius: 4,
                            transition: 'color 0.2s',
                            position: 'absolute',
                            right: 10,
                            top: 10
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.color = '#555')}
                        onMouseLeave={(e) => (e.currentTarget.style.color = '#999')}
                    />
                    <div className="PG__content">
                        <GaugeChart
                            media_geral={media_geral_uso?.media_geral}
                            media_solidos={media_geral_uso?.media_solidos}
                            media_liquidos={media_geral_uso?.media_liquidos}
                            media_sementes={media_geral_uso?.media_sementes}
                            is_empty={todas_atividades_ativas.length === 0}
                        />
                    </div>

                    <Modal
                        open={modalAberto}
                        onCancel={() => setModalAberto(false)}
                        footer={null}
                        title="Consumo de insumos"
                        width={600}
                        centered
                    >
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px 0', marginTop: 40 }}>
                            <GaugeChart
                                media_geral={media_geral_uso?.media_geral}
                                media_solidos={media_geral_uso?.media_solidos}
                                media_liquidos={media_geral_uso?.media_liquidos}
                                media_sementes={media_geral_uso?.media_sementes}
                                is_empty={todas_atividades_ativas.length === 0}
                                size={450}
                            />
                        </div>
                    </Modal>

                </PG>
            )}
        </AnimatePresence>
    )
};